import { PerspectiveCamera } from "three";
import {OrbitControls} from "three/addons/controls/OrbitControls.js";

export default class DtCamera extends PerspectiveCamera {
    constructor(renderer, x, y ,z) {
        const canvas = document.getElementById('canvas-3d');
        super(40, canvas.clientWidth / canvas.clientHeight, 0.1, 10000);
        this.position.x = x;
        this.position.y = y;
        this.position.z = z*1.2;

        const controls = new OrbitControls(this, renderer.domElement);
        controls.maxDistance = z*2;
        controls.target.set(x, y*5/6, 0);
        controls.update();
    }
}